import React from "react";
import { Chip, FormControl, Stack, Typography } from "@mui/material";

const PrefectureFilter = ({ prefectures, selectedPrefectures, onToggle }) => {
  return (
    <FormControl fullWidth>
      <Stack spacing={2}>
        <Typography
          variant="subtitle1"
          sx={{ fontFamily: "Poppins, sans-serif" }}
        >
          Select Prefectures
        </Typography>
        <Stack
          direction="row"
          flexWrap="wrap"
          gap={1}
          sx={{ fontFamily: "Poppins, sans-serif" }}
        >
          {prefectures.map((prefecture) => (
            <Chip
              key={prefecture}
              label={prefecture}
              clickable
              size="small"
              variant={
                selectedPrefectures.includes(prefecture) ? "filled" : "outlined"
              }
              onClick={() => onToggle(prefecture)}
              sx={{
                fontFamily: "Poppins, sans-serif",
                backgroundColor: selectedPrefectures.includes(prefecture)
                  ? "#70e000"
                  : "transparent",
                color: selectedPrefectures.includes(prefecture)
                  ? "#00171f"
                  : "#00171f",
                borderColor: "#00171f",
                "&:hover": {
                  backgroundColor: selectedPrefectures.includes(prefecture)
                    ? "#5cb300"
                    : "#f0f0f0",
                },
                minWidth: "unset",
                maxWidth: "100%",
              }}
            />
          ))}
        </Stack>
      </Stack>
    </FormControl>
  );
};

export default PrefectureFilter;
